export default {
    googleUrl: '//maps.googleapis.com/maps/api/js?sensor=true',
    baiduUrl: 'https://sapi.map.baidu.com/api?v=2.0&ak=KQMz9KcIzBwWNUgbHWUHZGSD&s=1&callback=initializeBaidu',
    baiduKey: 'KQMz9KcIzBwWNUgbHWUHZGSD'
};
